import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Phone } from 'lucide-react';
import { hasStickyBar, isShopPath } from '../lib/productPath';

// Not shown on shop pages (price list, collections, products, cart): buying
// online is what those pages are for, and Help sits in the header instead.
// Hidden on phones on the calculator, which has its own sticky bar.

export const PhoneFloat = () => {
  const [highlight, setHighlight] = useState(false);
  const { pathname } = useLocation();
  const onProduct = hasStickyBar(pathname);

  // Team pages (/admin/...) are not for customers: no call button there.
  const onShop = isShopPath(pathname) || pathname.startsWith('/admin');

  useEffect(() => {
    if (onShop) return undefined;
    const interval = setInterval(() => {
      setHighlight(true);
      setTimeout(() => setHighlight(false), 2000);
    }, 5000);

    return () => clearInterval(interval);
  }, [onShop]);

  const handlePhoneClick = (e) => {
    e.preventDefault();
    const url = 'tel:+917703900307';
    if (typeof window !== 'undefined' && window.gtagSendEvent) {
      window.gtagSendEvent(url);
    } else {
      window.location.href = url;
    }
  };

  // Shop pages: no floating button at all; Help in the header instead.
  if (onShop) return null;

  return (
    <a
      href="tel:+917703900307"
      onClick={handlePhoneClick}
      data-testid="phone-float-button"
      className={`${onProduct ? 'hidden lg:block' : ''} fixed bottom-24 right-6 z-50 bg-blue-600 hover:bg-blue-700 text-white rounded-full p-4 shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110`}
      style={highlight ? {
        boxShadow: '0 0 0 0 rgba(37, 99, 235, 0.7)',
        animation: 'phoneHighlight 2s ease-out forwards'
      } : {}}
      aria-label="Call Now"
    >
      <Phone size={28} />
    </a>
  );
};